export default __webpack_public_path__ + "static/media/sanjivani-tea-box.b681bc25.png";